if (!customElements.get('search-suggestions')) {
  const SearchSuggestions = class extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      this.searchInput = this.closest('form').querySelector('input[name="q"]');
      this.mobileSearchLink = this.closest('.header-search-wrap')?.querySelector('.mobile_search_link');
      this.mobileSearchClose = this.closest('.header-search-wrap')?.querySelector('.main-search__close');
      this.searchInput.addEventListener('keyup', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('focus', this.handleInputFocus.bind(this));
      if(this.mobileSearchLink){
        this.mobileSearchLink.addEventListener('click', this.openMobileSearch.bind(this));
      }
      if(this.mobileSearchClose){
        this.mobileSearchClose.addEventListener('click', this.closeMobileSearch.bind(this));
      }
    }

    openMobileSearch(event) {
      event.preventDefault();
      event.stopPropagation();
      this.closest('.header-search-wrap').classList.add('is-active');
      this.closest('.header-search-wrap').querySelector('.main-search__input').focus();
    }

    closeMobileSearch(event) {
      event.preventDefault();
      event.stopPropagation();
      this.closest('.header-search-wrap').classList.remove('is-active');
      this.closest('body').classList.remove('is-search-active');
    }

    handleInputFocus() {
      this.closest('.main-search__form').classList.add('search-suggestions-open');
    }

    handleInputChange() {
      const valueToSearch = this.searchInput.value;

      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        clearTimeout(this.searchTimeoutID);

        this.searchTimeoutID = setTimeout(() => {
          this.fetchSuggestions(valueToSearch);
        }, 500);
      } else if (!valueToSearch.length) {
        clearTimeout(this.searchTimeoutID);

        if (this.searchSuggestionsAbortController) {
          this.searchSuggestionsAbortController.abort('Existing request not needed');
          this.searchSuggestionsAbortController = null;
        }

        this.innerHTML = '';
      }

      this.oldSearchValue = valueToSearch;
    }

    fetchSuggestions(terms) {
      if (this.searchSuggestionsAbortController) {
        this.searchSuggestionsAbortController.abort('Existing request not needed');
      }
      this.closest('.main-search__form').classList.add('search-suggestions-open');

      this.searchSuggestionsAbortController = new AbortController();

      let loaderHTML = `<div class="search-suggestions__loader-wrap"><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 50'><circle fill='#030001' stroke='#030001' stroke-width='7' r='15' cx='40' cy='25'><animate attributeName='opacity' calcMode='spline' dur='2' values='1;0;1;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.4'></animate></circle><circle fill='#030001' stroke='#030001' stroke-width='7' r='15' cx='100' cy='25'><animate attributeName='opacity' calcMode='spline' dur='2' values='1;0;1;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.2'></animate></circle><circle fill='#030001' stroke='#030001' stroke-width='7' r='15' cx='160' cy='25'><animate attributeName='opacity' calcMode='spline' dur='2' values='1;0;1;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='0'></animate></circle></svg></div>`;
      if (!this.querySelector('.search-suggestions__loader-wrap')) {
        if (this.querySelector('.search-suggestions')) {
          this.querySelector('.search-suggestions').insertAdjacentHTML('afterbegin', loaderHTML);
        }else{
          this.insertAdjacentHTML('afterbegin', `<div class="search-suggestions">${loaderHTML}</div>`);
        }
      }

      fetch(`${theme.routes.predictiveSearch}?q=${encodeURIComponent(terms)}&resources[type]=product&section_id=search-suggestions`, {
        signal: this.searchSuggestionsAbortController.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.search-suggestions-wrapper');

          this.innerHTML = '';
          this.insertAdjacentElement('beforeend', results.firstElementChild);
          StampedFn.loadBadges();
        })
        .catch((error) => {
          console.warn(error);
          if (error.code === 20) {
            return; // aborted
          }
          throw error;
        });
    }
  };

  window.customElements.define('search-suggestions', SearchSuggestions);
}
document.addEventListener('click', function (e) {
  const searchForms = document.querySelectorAll('.main-search__form');

  searchForms.forEach(function (form) {
    // If click is outside this specific form
    if (!form.contains(e.target)) {
      form.classList.remove('search-suggestions-open');
    }
  });
});

document.querySelector('.mobile-drawer-search .main-search__input').addEventListener('focus', function (e) {
  document.querySelector('body').classList.add('is-search-active');
  document.querySelector('.header-search-wrap').classList.add('is-active');
  document.querySelector('.header-search-wrap .main-search__input').focus();
});